export default __webpack_public_path__ + "static/media/THE-GUIDE-FOR-THE-BEREAVED.8e5946af.pdf";